<div class="mainAuction_Card">
    <div class="card_image">
        <img [src]="AuctionDetailes.small_image" onerror="this.src='assets/images/default-img.png'" alt="">
        <div class="multiIcon" *ngIf="AuctionDetailes?.is_multi_auction">
            {{"multiAuction.Items in Queue"|translate}}
        </div>
        <div class="normalIcon" *ngIf="!AuctionDetailes?.is_multi_auction">
            {{"multiAuction.Item by Item"|translate}}
        </div>

        <div class="unpublished" *ngIf="_config._router.url!='/' && !AuctionDetailes.is_active" IsAdmin>
            {{'items-requests.Unpublished' | translate}}
        </div>
    </div>
    <div class="timer">
        <span [ngSwitch]="true">
            <p *ngSwitchCase="AuctionDetailes.type==='upcoming'">

                <timer [Mode]="'dark'" type="date" [time]="AuctionDetailes.remaining_time" [startORend]="1">
                </timer>
            </p>
            <p *ngSwitchCase="AuctionDetailes.type==='ongoing'&&!AuctionDetailes?.is_multi_auction">
                <timer [Mode]="'light'" type="date" [time]="AuctionDetailes.remaining_time" [startORend]="2">
                </timer>
            </p>
            <div *ngSwitchCase="AuctionDetailes.type==='ongoing'&&AuctionDetailes?.is_multi_auction">
                <div id="MultiAuction" class="timer_light" *ngIf="!AuctionDetailes?.is_pause">
                    <div class="text"> {{"multiAuction.It will end soon"|translate}}
                    </div>
                </div>

                <div id="MultiAuction" class="timer_light" *ngIf="AuctionDetailes?.is_pause">
                    <div class="text"> {{"multiAuction.The auction is temporarily paused"|translate}}
                    </div>
                </div>

            </div>
            <p *ngSwitchDefault>
                <timer [Mode]="'light'" type="date" [time]="AuctionDetailes.remaining_time" [startORend]="3">
                </timer>
            </p>
        </span>
    </div>
    <div class="card_content">
        <div class="card_title">{{AuctionDetailes.name}}</div>
        <div class="card_desc">
            <!-- <div class="mb-2" IsAdmin>
                <span [ngSwitch]="AuctionDetailes.is_active">
                    <p *ngSwitchCase="1" class="published">
                        {{'Main Auction.published' | translate}}
                    </p>
                    <p *ngSwitchCase="0" class="unpublished">
                        {{'items-requests.Unpublished' | translate}}
                    </p>
                    <p *ngSwitchDefault>

                    </p>
                </span>
            </div> -->
            <div class="item">
                <img src="./assets/images/icons/calender.svg" alt="">
                <span> {{AuctionDetailes.date_format_start_end}}</span>
            </div>
            <div class="item">
                <img src="./assets/images/icons/items.svg" alt="">
                <span> {{AuctionDetailes.auctions_count}} {{"Home.items"|translate}}</span>
            </div>

            <div class="item" *ngIf="AuctionDetailes?.permitting_without_enough_balance">
                <img src="./assets/images/icons/items.svg" alt="" [matTooltip]="'Auction Item.Allow biddig over your wallet'|translate">
                <span *ngIf="AuctionDetailes?.is_percentage">
                    {{AuctionDetailes.permitting_value}}%
                </span>
                <span *ngIf="!AuctionDetailes?.is_percentage">
                    {{AuctionDetailes.permitting_value}} {{"Auction Item.SR"|translate}}
                </span>
            </div>
            <!-- <div class="item" *ngIf="AuctionDetailes?.permitting_without_enough_balance">
                <img src="./assets/images/icons/items.svg" alt="">
                <span *ngIf="AuctionDetailes?.is_percentage">
                    Percentage: {{AuctionDetailes.permitting_value}}%
                </span>
                <span *ngIf="!AuctionDetailes?.is_percentage">
                    Amount : {{AuctionDetailes.permitting_value}} SR
                </span>
            </div> -->
        </div>
        <div class="card_footer">
            <div class="cost">
                <p class="lable" *ngIf="!AuctionDetailes?.is_multi_auction">{{"Home.Minimum bid"|translate}}</p>
                <p class="lable" *ngIf="AuctionDetailes?.is_multi_auction">{{"multiAuction.Entry fee"|translate}}</p>
                <p> <span>{{"Home.SR"|translate}}</span>
                    {{AuctionDetailes.minimum_price_or_entry_fee?(AuctionDetailes.minimum_price_or_entry_fee|number):0}}
                </p>
            </div>
            
        </div><div class="details_btn mt-2">
                <button mat-button class="btnLight_fill w-100"
                    (click)="OnNavigate(AuctionDetailes.id)">{{"Home.Details"|translate}}</button>
            </div>
    </div>

</div>